/**
 * 1px visible grab strip between Miller-column panes; the widened inset span makes it easy to hit.
 *
 * Named with `aria-label`, not a native `title`: the column cursor already says
 * what the strip does, and a browser title is the unstyled tooltip the design
 * system rules out.
 */

import type { PointerEvent as ReactPointerEvent } from "react";

export function ResizeHandle({ onPointerDown }: { onPointerDown: (e: ReactPointerEvent) => void }) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label="Drag to resize"
      onPointerDown={onPointerDown}
      className="group relative w-1 shrink-0 cursor-col-resize bg-border/40 transition-colors hover:bg-primary/50"
    >
      <span className="absolute inset-y-0 -left-1 -right-1" />
    </div>
  );
}
